import api from "../api/axios";

const url = `api/final-documents`;

export const getFinalDocuments = async (employee_id) => {
  try {
    const response = await api.get(
      employee_id ? `${url}?employee_id=${employee_id}` : url
    );
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};

export const getLetterHead = async () => {
  try {
    const response = await api.get(`${url}/letter-head`);
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};

export const generateFinalDocuments = async (payload) => {
  try {
    const response = await api.post(`${url}/generate`, payload);
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};

export const previewFinalDocument = async (payload) => {
  try {
    const response = await api.post(`${url}/preview`, payload);
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};
